import {
  DefaultButton,
  PrimaryButton,
  Dialog,
  DialogFooter,
  DialogType,
  MessageBar,
  MessageBarType,
  Spinner,
} from '@fluentui/react';
import {useState} from 'react';
import commonStyles from '../../common/commonStyles.module.scss';
import {Client} from '../../Swagger/api';
import {getApis} from '../../webservices';

interface IClientRemove {
  onDone: () => void;
  onCancel: () => void;
  client: Client;
}

export const ClientRemove = (props: IClientRemove) => {
  const [loading, setLoading] = useState(false);
  const [hasError, setHasError] = useState(false);

  const onDelete = async () => {
    setLoading(true);
    setHasError(false);

    try {
      const {clientClient} = await getApis();
      await clientClient.removeClient(props.client.id);
      props.onDone();
    } catch {
      setHasError(true);
      setLoading(false);
    }
  };

  return (
    <Dialog
      hidden={false}
      dialogContentProps={{
        title: 'Delete client',
        type: DialogType.normal,
      }}
      modalProps={{
        isBlocking: true,
      }}
      minWidth="40em"
      onDismiss={props.onCancel}
    >
      <p>
        Deleting the client <strong>{props.client.companyName}</strong> will
        delete all his subscriptions, configured domains and product settings.
        The data can not be recovered. Are you sure?
      </p>
      <DialogFooter>
        <section className={commonStyles.dialogMessages}>
          {loading ? (
            <Spinner
              className={commonStyles.spinner}
              label="Please wait"
              ariaLive="assertive"
              labelPosition="right"
            />
          ) : null}
          {hasError ? (
            <MessageBar
              className={commonStyles.messageBar}
              messageBarType={MessageBarType.error}
              isMultiline={true}
              dismissButtonAriaLabel="Close"
            >
              Something went wrong. Please try again or contact an
              Administrator.
            </MessageBar>
          ) : null}
        </section>

        <PrimaryButton
          className={commonStyles.delete}
          onClick={onDelete}
          text="Delete"
        />
        <DefaultButton onClick={props.onCancel} text="Cancel" />
      </DialogFooter>
    </Dialog>
  );
};
